import React from "react";

export function Select({ children, className, inputProps, error, ...rest }) {
  return (
    <select className={className} {...inputProps} {...rest}>
      {children}
    </select>
  );
}
